if (!customElements.get('product-pads-bundle-form')) {
  customElements.define('product-pads-bundle-form', class ProductPadsBundleForm extends HTMLElement {
     static observedAttributes = ["data-maxproduct"];
    constructor() {
      super();
      this.maxNumber = this.dataset.maxproduct;
      this.quantityCounter = 0;
      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('.custom-bundle-default-pads');
      this.quantityButtons = this.querySelectorAll(".quantity-button");
        
      this.quantityBoxOpenrButtons = this.querySelectorAll(".custom-item-qty-opener");
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.activeTabValue = this.querySelector(".bundle-pads-option-selector input:checked").value;
      this.activeTabElement = this.querySelector(".bundle-pads-option-content.content-active");
      this.optionSelectors = this.querySelectorAll(".bundle-main-radio-option-selecor");
      this.mainIdSelector = this.form.querySelector(`input[name="id"]`);
      this.enabledofferet = this.dataset.enabledofferet;
      this.enabledofferetProducts = this.dataset.offeretproducts;
        
      this.initEventListeners();
      
    }
    initEventListeners(){
      this.quantityButtons.forEach( (el) => {
        el.addEventListener("click",this.quantityChangeHandler.bind(this));
      });
      this.quantityBoxOpenrButtons.forEach( (el) => {
        el.addEventListener("click",this.openQuantityBox.bind(this));
      });
      this.optionSelectors.forEach( (el) => {
        el.addEventListener("change",this.onOptionChange.bind(this));
      });
       this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }
    onOptionChange(evt){
      const activeValue = evt.target.value;
      const activeVariant = evt.target.dataset.vid;
      this.mainIdSelector.value = activeVariant;
      this.querySelectorAll(".bundle-pads-option-selector").forEach((el)=>{
        el.classList.remove("checked-active");
      });
      const currentElement = evt.target.parentElement;
      currentElement.classList.add("checked-active");
      this.querySelectorAll(".bundle-pads-option-content").forEach((el)=>{
        el.classList.add("hide");
        el.classList.remove("content-active");
      });
      this.querySelector(`.bundle-pads-option-content[data-type="${activeValue}"]`).classList.remove("hide");
      this.querySelector(`.bundle-pads-option-content[data-type="${activeValue}"]`).classList.add("content-active");
      let osInstance;
      if(osInstance){
        osInstance.destroy();
      }
       osInstance = OverlayScrollbars(this.querySelector(`.bundle-pads-option-content[data-type="${activeValue}"]`),{});   
      this.updateStateAndValue();
    }
    updateStateAndValue(){
      this.quantityCounter = 0;
      this.activeTabValue = this.querySelector(".bundle-pads-option-selector input:checked").value;
      this.activeTabElement = this.querySelector(".bundle-pads-option-content.content-active");
      this.activeTabElement.querySelectorAll(".custom-qty-box-input").forEach((el) => {
        const currentQty = +el.value;
        this.quantityCounter = (this.quantityCounter + currentQty);
      });
      
       if(this.quantityCounter >= this.maxNumber){
         this.activeTabElement.querySelectorAll(".product-bundle-item-wrapper").forEach( (el) => {
           const mainElement = el;
           if(el.querySelector(".custom-qty-box-input").value > 0){
             el.querySelector("button.plus").setAttribute("disabled","disabled");
             el.querySelector("button.minus").removeAttribute("disabled");
           }else{
              el.classList.add("opacity-5");
              el.querySelector("button.plus").setAttribute("disabled","disabled");
              el.querySelector("button.minus").setAttribute("disabled","disabled");
              el.querySelector(".custom-item-qty-opener").setAttribute("disabled","disabled");
           }
           
         });
        this.submitButton.querySelector("span.bundle-message").classList.add("hide");
        this.submitButton.querySelector("span.add-to-cart-message").classList.remove("hide");
        this.submitButton.removeAttribute("disabled");
         
       }else{
         this.activeTabElement.querySelectorAll(".product-bundle-item-wrapper").forEach( (el) => {
           el.querySelector("button.plus").removeAttribute("disabled");
           el.classList.remove("opacity-5");
           el.querySelector(".custom-item-qty-opener").removeAttribute("disabled");
         });
         this.submitButton.querySelector("span.add-to-cart-message").classList.add("hide");
         this.submitButton.querySelector("span.bundle-message").classList.remove("hide");
         this.submitButton.setAttribute("disabled","disabled");
       }
      this.submitButton.querySelector("span.bundle-message .bundle-counter").textContent = `${this.quantityCounter}/${this.maxNumber}`;
      
    }
    openQuantityBox(evt){
        evt.preventDefault();
        let isFilled = true;
        const parentElement = evt.target.parentElement;
        const currentParentElement = evt.target.closest('.product-bundle-item-wrapper');
          parentElement.querySelector(".quantity-button.plus").click();
          parentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.remove("hide");
          evt.target.classList.add("hide");
         currentParentElement.classList.add("active");
    }
    quantityChangeHandler(evt){
      evt.preventDefault();
      
      const inputElement = evt.target.parentElement.querySelector('.custom-qty-box-input');
       const currentParentElement = evt.target.closest('.product-bundle-item-button');
      if(evt.target.classList.contains('plus')){
        
        if(this.quantityCounter < this.maxNumber){
          inputElement.stepUp();
          this.quantityCounter++;
          currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        }
        if(inputElement.value > 0){
          evt.target.parentElement.querySelector('button.minus').removeAttribute("disabled");
        }
      }else{
        if(this.quantityCounter > 0){
          inputElement.stepDown();
          this.quantityCounter--;
          currentParentElement.querySelector(".display-qty").textContent= inputElement.value;
        }
        if(inputElement.value <= 0){
          evt.target.parentElement.querySelector('button.minus').setAttribute("disabled","disabled");
          currentParentElement.querySelector(".product-bundle-item-quantity-wrapper").classList.add("hide");
          currentParentElement.querySelector(".custom-item-qty-opener").classList.remove("hide");
          
        }
      }
       if(this.quantityCounter > 0 ){
           this.optionSelectors.forEach((el) => {
             if(el.checked == false){
               el.setAttribute("disabled","disabled");
             }
           });
        }else{
          this.optionSelectors.forEach((el) => {
               el.removeAttribute("disabled");
           });
        }
      this.updateStateAndValue();
    }
      attributeChangedCallback(name, oldValue, newValue) {
         this.maxNumber = newValue;
        console.log(this.maxNumber, name,oldValue,newValue );
  }
    onSubmitHandler(evt) {
      evt.preventDefault();
      this.handleErrorMessage();

      const mainId = this.mainIdSelector.value;
      const bundleId = new Date().getTime();      
     let items = [];
      let bundlerItem = 0;
      let allProperties = [];
      this.activeTabElement.querySelectorAll(".product-bundle-item-quantity-wrapper .custom-qty-box-input").forEach( (el) => {
        if(el.value > 0){
          allProperties.push(el.dataset.vtitle);
          items.push({
            "id":el.dataset.vid,
            "quantity":el.value,
            "properties":{
              "_customBundleId":bundleId,
              "_isMainProduct":0,
              "_baseQty":el.value
            }
          });
          bundlerItem++;
        }
      });
      if(bundlerItem <= 0){
        return false;
      }
      if( this.enabledofferet === 'true'){
          if(this.enabledofferetProducts){
            const enabledofferetProductsdata = this.enabledofferetProducts.split("___");
            if(enabledofferetProductsdata.length > 0){
              for(let i in enabledofferetProductsdata){
                if(enabledofferetProductsdata[i]){
                  const slitthestring = enabledofferetProductsdata[i].split("||");
                  let productTitle = slitthestring[1];
                  if(slitthestring[2]){
                    if(slitthestring[2].indexOf("Default") > -1){
                    }else{
                      productTitle = `${productTitle}:${slitthestring[2]}`
                    }
                  }
                  allProperties.push(productTitle);
                  items.push({
                    "id":slitthestring[0],
                    "quantity":1,
                    "properties":{
                      "_customBundleId":bundleId,
                      "_isMainProduct":0,
                      "_baseQty":1,
                      "_isOffertAddon":1
                    }
                  });
                }
              }
            }
          }
        }
       items.push(
        {
          "id":mainId,
          "quantity":1,
          "properties":{
            "_customBundleId":bundleId,
            "_isMainProduct":1,
            "Contenu":allProperties.join("|")
          }
        }
      );
      let formData = {
       'items':items,
      };
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => {
         $("body").trigger("added.ajaxProduct");
        this.closest(".custom-modal__centered.active").classList.remove("active");
      });
    }
     connectedCallback() {
         this.closest(".custom-modal__centered").classList.add("custom-pads-bundle-enabled");
     }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;

      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}
